import { render } from "./MyEvents.vue?vue&type=template&id=46842bb9&scoped=true"
import script from "./MyEvents.vue?vue&type=script&lang=js"
export * from "./MyEvents.vue?vue&type=script&lang=js"

import "./MyEvents.vue?vue&type=style&index=0&id=46842bb9&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46842bb9"]])

export default __exports__